import * as LDClient from 'launchdarkly-js-client-sdk';
import config from './../../config';
import { isInternalStaff } from '../../utils/user';
import { ENV } from './../../environment';
const CONFIG = config[ENV];

export const isUploadAccessBlocked = (featureFlags, currentUser) => {
  return Boolean(
    featureFlags.block_upload_access && !isInternalStaff(currentUser),
  );
};

export default {
  state: {
    featureFlags: [],
  },
  mutations: {
    setFeatureFlags(state, user) {
      if (!user) {
        return;
      }

      const context = {
        key: user.id.toString(),
        kind: 'user',
        organisation_name: user.organisation.name,
      };
      const client = LDClient.initialize(CONFIG.launch_darkly.key, context, {
        hash: user.launch_darkly_hash,
      });
      client.on('ready', () => {
        state.featureFlags = client.allFlags();
      });
    },
  },
  getters: {
    trustSignalsEnabled: (state) => state.featureFlags.serialize_trust_signals,
    documentStatusEnabled: (state) =>
      state.featureFlags['create-document-review-status'],
    documentFilteringEnabled: (state) =>
      state.featureFlags['document-review-status-filtering'],
    canUseCredit: (state) =>
      state.featureFlags.is_credit_analysis_endpoint_enabled,
    creditConfidenceScoreEnabled: (state) =>
      state.featureFlags.credit_confidence_score_enabled,
    creditConfidenceScoreThreshold: (state) => {
      const fallbackConfidenceScore = 0.5;
      return (
        parseFloat(state.featureFlags.credit_confidence_score_threshold) ||
        fallbackConfidenceScore
      );
    },
    creditTransactionsSearchFiltersEnabled: (state) =>
      state.featureFlags.credit_transactions_search_filters,
    creditBulkRecategorisationEnabled: (state) =>
      state.featureFlags.credit_bulk_recategorisation_enabled,
    creditInsightsIsAvailableBannerEnabled: (state) =>
      state.featureFlags.credit_insights_is_available_banner,
    creditInsightsTabPreviewEnabled: (state) =>
      state.featureFlags.credit_insights_tab_preview,
    creditInsightsTabsEnabled: (state, getters) =>
      getters.canUseCredit || getters.creditInsightsTabPreviewEnabled,
    creditDisableTrustScoreAlert: (state) =>
      state.featureFlags.credit_disable_trust_score_alert,
    creditMonthlyTableViewEnabled: (state) =>
      state.featureFlags.credit_monthly_table_view,
    creditReconciledDocsFilterEnabled: (state) =>
      state.featureFlags.credit_reconciled_docs_filter_enabled,
    creditReconciledDocsFilterDefaultValue: (state) =>
      state.featureFlags.credit_reconciled_docs_filter_default_value,
    creditAgentEnabled: (state) => state.featureFlags.enable_credit_agent,
    collectEnabled: (state) =>
      state.featureFlags['new-collect-session-button-enabled'],
    parsedDetailHighlighterEnabled: (state) =>
      state.featureFlags['parsed-detail-highlighter'],
    isWorkspacesEnabled: (state) =>
      state.featureFlags.is_workspace_permissions_enabled,
    isCollectCustomerInformationFormEnabled: (state) =>
      state.featureFlags.collect_customer_information_form,
    isCollectLiveCaptureEnabled: (state) =>
      state.featureFlags.collect_live_capture_mode,
    isWorkspaceCreationEnabled: (state) =>
      state.featureFlags.is_workspace_creation_enabled,
    isUploadAccessBlocked: (state, _, rootState) =>
      isUploadAccessBlocked(state.featureFlags, rootState.currentUser),
    useOcrForTruPdfCalculations: (state) =>
      state.featureFlags['use-ocr-for-document-calculations'],
    showSimilarDocuments: (state) =>
      state.featureFlags['similar-document-search-enabled'],
    canViewDocumentReviewAgent: (state) =>
      state.featureFlags.view_document_review_agent,
    canViewCustomerReviewAgent: (state) =>
      state.featureFlags.view_customer_review_agent,
    hideCreditWhenLowConfidenceScore: (state) =>
      state.featureFlags.hide_credit_low_confidence_score,
  },
};
